
<!-- customizacao de layout de etiqueta

COMO UTILIZAR:

<div class="col-12">
    <layout-etiqueta ></layout-etiqueta>
</div>


-->
<script>

import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
    name: 'layout-etiqueta',
    props: {
        dadosEtiqueta: {type: Object},
        isView: { type: Boolean, default: false }
    },

    components: { VueDraggableResizable },

    data () {
        return {
            fields: [],
            multiplicador_etiqueta: 1,
            multiplicador_pagina: 1,
            items: [],
            items_backup: [],
            optionsCurrency:[{id:'RL', text:'BRL(R$)'}, {id:'US', text:'USD($)'},{id:'EU', text:'EUR(€)'},{id:'GB', text:'EUR(€)'}],
            optionsFont:[
                {id:'Courier', text:'Courier'},
                {id:'Courier-Bold', text:'Courier-Bold'},
                {id:'Courier-Oblique', text:'Courier-Oblique'},
                {id:'Courier-BoldOblique', text:'Courier-BoldOblique'},
                {id:'Helvetica', text:'Helvetica'},
                {id:'Helvetica-Bold', text:'Helvetica-Bold'},
                {id:'Helvetica-Oblique', text:'Helvetica-Oblique'},
                {id:'Helvetica-BoldOblique', text:'Helvetica-BoldOblique'},
                {id:'Symbol', text:'Symbol'},
                {id:'Times-Roman', text:'Times-Roman'},
                {id:'Times-Bold', text:'Times-Bold'},
                {id:'Times-Italic', text:'Times-BoldItalic'},
                {id:'ZapfDingbats', text:'ZapfDingbats'},
            ],
            optionsTypeGTIN:[{id: 'CB', text:'Código de Barras'}, {id: 'TX', text: 'Texto'}],
            optionsFormatGTIN:[
                {id: 'EAN13', text:'EAN13'},
                {id: 'EAN8', text:'EAN8'},
                {id: 'EAN5', text:'EAN5'},
                {id: 'EAN2', text:'EAN2'},
                {id: 'MSI', text: 'MSI'},
                {id: 'MSI10', text: 'MSI10'},
                {id: 'MSI11', text: 'MSI11'},
                {id: 'MSI1010', text: 'MSI1010'},
                {id: 'MSI1110', text: 'MSI1110'},
                {id: 'UPC', text: 'UPC'},
                {id: 'ITF14', text: 'ITF14'},
                {id: 'pharmacode', text: 'PHARMACODE'},
                {id: 'CODE39', text: 'CODE39'},
                {id: 'CODE128', text: 'CODE128'},
                {id: 'codabar', text: 'CODABAR'},
             ],
            typeOfField: 'produto',
            pagina: {
                format: '4',
                largura: 210,
                altura: 297,
                margin: {
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5,
                }
            },
            etiqueta: {
                largura: 80,
                altura: 30,
                espacamento_horizontal: 5,
                espacamento_vertical: 5,
            },
            item: null,
            tabs: [
                {title: 'Etiqueta', icon:''},
                {title: 'Pagina', icon:''},
            ],
            activeTab: 0,
            focusVertical: false,
            focusHorizontal: false,
            focusSuperior: false,
            focusInferior: false,
            focusDireita: false,
            focusEsquerda: false,
            formatOptions: [
                { id: 1, text: "Personalizado" },
                { id: 2, text: "A2" },
                { id: 3, text: "A3" },
                { id: 4, text: "A4" },
                { id: 5, text: "A5" }
            ]
        }
    },

    methods: {
        handleCancelItem(item){
            this.items.map((e, i) =>{
                if (e.index == item.index) {
                    this.items.splice (i,1)
                }
            })

            this.items.map((e,i) =>{
                e.index = i
            })
            this.item = null;
        },
        // handleBold(){
        //     this.$set(this.item, 'selectedBold', !this.item.selectedBold)
        // },
        // handleItalic(){
        //     this.$set(this.item, 'selectedItalic', !this.item.selectedItalic)
        // },
        handleTextStyle(item){
            let fontSize = ''
            let textFont = ''
            let selectedBold = false
            let selectedItalic = false
            if(item.fontSize){
                fontSize = `font-size: ${item.fontSize}px`
            }
            if(item.textFont){
                textFont = `font-family: ${item.textFont}`
            }
            // if(item.selectedBold){
            if ((item.textFont+"").toUpperCase().includes("bold".toUpperCase())){
                selectedBold = 'font-weight: bold'
            }
            // if(item.selectedItalic){
            if ((item.textFont+"").toUpperCase().includes("italic".toUpperCase())){
                selectedItalic = 'font-style: italic'
            }

            return `${fontSize}; ${textFont}; ${selectedBold}; ${selectedItalic};`
        },
        focus () {

        },

        onFocusVertical() {
            this.focusVertical = true
            this.preview_pagina_nexttick()
        },

        onBlurVertical() {
            this.focusVertical = false
            this.preview_pagina_nexttick()
        },

        onFocusHorizontal() {
            this.focusHorizontal = true
            this.preview_pagina_nexttick()
        },

        onBlurHorizontal() {
            this.focusHorizontal = false
            this.preview_pagina_nexttick()
        },

        onFocusSuperior() {
            this.focusSuperior = true
            this.preview_pagina_nexttick()
        },

        onBlurSuperior() {
            this.focusSuperior = false
            this.preview_pagina_nexttick()
        },

        onFocusInferior() {
            this.focusInferior = true
            this.preview_pagina_nexttick()
        },

        onBlurInferior() {
            this.focusInferior = false
            this.preview_pagina_nexttick()
        },

        onFocusDireita() {
            this.focusDireita = true
            this.preview_pagina_nexttick()
        },

        onBlurDireita() {
            this.focusDireita = false
            this.preview_pagina_nexttick()
        },

        onFocusEsquerda() {
            this.focusEsquerda = true
            this.preview_pagina_nexttick()
        },

        onBlurEsquerda() {
            this.focusEsquerda = false
            this.preview_pagina_nexttick()
        },

        setFormat() {
            if (this.pagina.format == 1) {
                this.pagina.largura = 210
                this.pagina.altura = 297
                this.preview_pagina_nexttick()
                return
            }

            if (this.pagina.format == 2) {
                this.pagina.largura = 420
                this.pagina.altura = 594
                this.preview_pagina_nexttick()
                return
            }

            if (this.pagina.format == 3) {
                this.pagina.largura = 297
                this.pagina.altura = 420
                this.preview_pagina_nexttick()
                return
            }

            if (this.pagina.format == 4) {
                this.pagina.largura = 210
                this.pagina.altura = 297
                this.preview_pagina_nexttick()
                return
            }

            if (this.pagina.format == 5) {
                this.pagina.largura = 148
                this.pagina.altura = 210
                this.preview_pagina_nexttick()
                return
            }
        },

        preview_pagina_nexttick(){
            this.$nextTick(function () {
                this.preview_pagina()
            })
        },

        saveLayout() {
            let layoutConfig = {}
            layoutConfig.items = this.items
            layoutConfig.pagina = this.pagina
            layoutConfig.etiqueta = this.etiqueta

            return layoutConfig
        },

        getFields(){
            let aux = []
            if (this.dadosEtiqueta.tipo == 'P'){
                aux.push({name:'item.descricao', family:'produto', label:'Nome'});
                aux.push({name:'item.codigo', family:'produto', label:'Codigo'});
                aux.push({name:'item.canp', family:'produto', label:'Codigo ANP'});
                aux.push({name:'item.vlr', family:'produto', label:'Preço de Venda'});
                aux.push({name:'item.cuspadrao', family:'produto', label:'Custo'});
                aux.push({name:'item.pliq', family:'produto', label:'Peso Líquido'});
                aux.push({name:'item.pbru', family:'produto', label:'Peso Bruto'});
                aux.push({name:'item.comprimento', family:'produto', label:'Comprimento (cm)'});
                aux.push({name:'item.largura', family:'produto', label:'Largurai (cm)'});
                aux.push({name:'item.espessura', family:'produto', label:'Espessura (cm)'});
                aux.push({name:'item.codbarras', family:'produto', label:'GTIN'});

                aux.push({name:'filial.nome', family:'empresa', label:'Nome'});
                aux.push({name:'filial.fantasia', family:'empresa', label:'Fantasia'});
                aux.push({name:'filial.cnpj', family:'empresa', label:'CNPJ'});
                aux.push({name:'filial.cep', family:'empresa', label:'CEP'});
                aux.push({name:'filial.ende', family:'empresa', label:'Endereço'});
                aux.push({name:'filial.endenr', family:'empresa', label:'Endereço Nr.'});
                aux.push({name:'filial.endecomp', family:'empresa', label:'Complemento'});
                aux.push({name:'filial.bairro', family:'empresa', label:'Bairro'});
                aux.push({name:'filial.uf', family:'empresa', label:'UF'});
                aux.push({name:'filial.nomemun', family:'empresa', label:'Município'});
                aux.push({name:'filial.fone1', family:'empresa', label:'Telefone 1'});
                aux.push({name:'filial.fone2', family:'empresa', label:'Telefone 2'});
                aux.push({name:'filial.fone3', family:'empresa', label:'Telefone 3'});
                aux.push({name:'filial.email', family:'empresa', label:'E-mail'});
                aux.push({name:'filial.site', family:'empresa', label:'Site'});
                aux.push({name:'filial.iest', family:'empresa', label:'iest'});

                aux.push({name:'outros.texto', family:'outros', label:'Texto'});
                aux.push({name:'outros.date', family:'outros', label:'Data Atual'});

            }
            return aux
        },

        changeTab(idx){
            this.activeTab = idx
            if (this.activeTab == 1)
                this.preview_pagina_nexttick()
        },

        startDragFields (evt, item) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('fieldID', item.name)
        },

        onDropFields (evt) {
            console.log(evt)
            const fieldID = evt.dataTransfer.getData('fieldID')
            if (!fieldID){
                return;
            }
            const field = this.fields.find(item => item.name == fieldID)

            const clonefield = JSON.parse(JSON.stringify(field));
            clonefield.index = this.items.length
            clonefield.x = 0
            clonefield.y = 0
            clonefield.width = 20
            clonefield.height = 7
            clonefield.textFont = "Times-Roman"
            clonefield.fontSize = 12
            // clonefield.selectedBold = false
            // clonefield.selectedItalic = false
            clonefield.rotudo = null
            clonefield.typeGTIN = null
            clonefield.formatGTIN = null
            clonefield.codemtexto = false
            if (clonefield.name == 'item.codbarras'){
                clonefield.typeGTIN = 'CB'
                clonefield.formatGTIN = 'EAN13'
            }
            clonefield.obs = null
            this.items.push(clonefield)
            evt.dataTransfer.setData('fieldID', null)
        },

        onResizeItem: function (index, x, y, width, height) {
            const field = this.items.find(item => item.index == index)
            field.x = this.pxTomm(Number(x))
            field.y = this.pxTomm(Number(y))
            field.width = this.pxTomm(Number(width))
            field.height = this.pxTomm(Number(height))
        },

        onDragingItem: function (index, x, y) {
            const field = this.items.find(item => item.index == index)
            this.item = field
            field.x = this.pxTomm(Number(x))
            field.y = this.pxTomm(Number(y))
            field.fontSize = 12
        },

        onActivated(index) {
            const field = this.items.find(item => item.index == index)
            this.item = field
        },
        onDeactivated() {
            // this.item = null
        },

        calcula_etiqueta_largura(modoPagina){
            return this.etiqueta.largura / 0.264583333 * (modoPagina ? this.multiplicador_pagina : this.multiplicador_etiqueta)
        },

        calcula_etiqueta_altura(modoPagina){
            return this.etiqueta.altura / 0.264583333 * (modoPagina ? this.multiplicador_pagina : this.multiplicador_etiqueta)
        },

        pxTomm(value_px){
            let dpi = 96;
            if (document.getElementById("dpi") && document.getElementById("dpi").offsetHeight)
                dpi = document.getElementById("dpi").offsetHeight
            let mmDPI = 25.4 / Number(dpi)
            return Number(value_px) * mmDPI
        },

        mmTopx(value_mm){
            let dpi = 96;
            if (document.getElementById("dpi") && document.getElementById("dpi").offsetHeight)
                dpi = document.getElementById("dpi").offsetHeight
            let mmDPI = 25.4 / Number(dpi)
            return Number(value_mm) / mmDPI
        },

        preview_pagina(){
            var canvas = document.getElementById('canvas');

            if (!canvas) return;

            var ctx = canvas.getContext('2d');

            ctx.clearRect(0, 0, this.mmTopx(this.pagina.largura) , this.mmTopx(this.pagina.altura) );

            ctx.lineWidth = 1;

            ctx.font = "20px Arial";
            ctx.fillStyle = "red";
            ctx.fillText(this.pagina.largura+"x"+this.pagina.altura, 5, 15);

            ctx.strokeStyle = 'black';
            ctx.setLineDash([]);
            ctx.strokeRect(0, 0, this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.altura));

            // Define o Grid
            // for (let i = 0; i < (this.pagina.largura / 5); i++) {
            //     for (let j = 0; j < (this.pagina.altura / 5); j++) {
            //         ctx.strokeStyle = 'black';
            //         ctx.lineWidth = 1;
            //         ctx.strokeRect(5 * i, 5 * j , 5, 5);
            //     }
            // }

            for (let i = Number(this.pagina.margin.left); (i + Number(this.etiqueta.largura)) <= (Number(this.pagina.largura) - Number(this.pagina.margin.right) ); i = i + Number(this.etiqueta.largura) + Number(this.etiqueta.espacamento_horizontal)) {
                for (let j = Number(this.pagina.margin.top); (j + Number(this.etiqueta.altura)) <= (Number(this.pagina.altura) - Number(this.pagina.margin.bottom) ); j = j + Number(this.etiqueta.altura) + Number(this.etiqueta.espacamento_vertical)) {
                    let x = this.mmTopx(i)
                    let y = this.mmTopx(j)
                    ctx.font = "15px Arial";
                    ctx.fillStyle = "red";
                    ctx.fillText(this.etiqueta.largura+"x"+this.etiqueta.altura, x, y+10);

                   // Define a etiqueta
                    ctx.fillStyle = `rgba(55, 55, 55, 0.1)`;
                    ctx.fillRect(x, y, this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.altura));

                    // Define a borda tracejada da etiqueta
                    ctx.setLineDash([5, 5 ,5]);
                    ctx.strokeRect(x, y, this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.altura));

                    // Espacamento Horizontal
                    if (this.focusHorizontal)
                        if (i > Number(this.pagina.margin.left)){
                            ctx.fillStyle = `rgba(0, 255, 0, 0.6)`;
                            ctx.fillRect(x - this.mmTopx(Number(this.etiqueta.espacamento_horizontal)), y, this.mmTopx(this.etiqueta.espacamento_horizontal), this.mmTopx(this.etiqueta.altura));
                        }

                    // Espacamento Vertical
                    if (this.focusVertical)
                        if (j > Number(this.pagina.margin.top)){
                            ctx.fillStyle = `rgba(0, 0, 255, 0.6)`;
                            ctx.fillRect(x, y - this.mmTopx(Number(this.etiqueta.espacamento_vertical)), this.mmTopx(this.etiqueta.largura), this.mmTopx(this.etiqueta.espacamento_vertical));
                        }
                }
            }

            // Define as 4 bordas
            if (this.focusSuperior) {
                ctx.fillStyle = `rgba(245, 121, 49, 0.6)`;
                ctx.fillRect(0, 0, this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.margin.top));
                return;
            }

            if (this.focusEsquerda) {
                ctx.fillStyle = `rgba(245, 121, 49, 0.6)`;
                ctx.fillRect(0, 0, this.mmTopx(this.pagina.margin.left), this.mmTopx(this.pagina.altura));
                return;
            }

            if (this.focusDireita) {
                ctx.fillStyle = `rgba(245, 121, 49, 0.6)`;
                ctx.fillRect(this.mmTopx(this.pagina.largura - this.pagina.margin.right), 0, this.mmTopx(this.pagina.margin.right), this.mmTopx(this.pagina.altura));
                return;
            }

            if (this.focusInferior) {
                ctx.fillStyle = `rgba(245, 121, 49, 0.6)`;
                ctx.fillRect(0, this.mmTopx(this.pagina.altura - this.pagina.margin.bottom), this.mmTopx(this.pagina.largura), this.mmTopx(this.pagina.margin.bottom));
                return;
            }
        },
    },
    mounted(){
    },

    computed: {
        fieldWidth(){
            // if((this.item.family == 'produto' && this.item.name !== 'item.gtin') || this.item.family == 'outros' || this.item.family == 'empresa'){
                return true
            // }
        },
        fieldHeight(){
            // if((this.item.family == 'produto' && this.item.name !== 'item.gtin') || this.item.family == 'outros' || this.item.family == 'empresa'){
                return true
            // }
        },
        fieldTextFont(){
            if((this.item.family == 'produto' && this.item.name !== 'item.codbarras') || this.item.family == 'outros' || this.item.family == 'empresa'){
                return true
            }
        },
        fieldFontSize(){
            if((this.item.family == 'produto' && this.item.name !== 'item.codbarras') || this.item.family == 'outros' || this.item.family == 'empresa'){
                return true
            }
        },
        fieldRotulo(){
            if((this.item.family == 'produto' && this.item.name !== 'item.codbarras') || this.item.family == 'outros' || this.item.family == 'empresa'){
                return true
            }
        },
        fieldObs(){
            if(this.item.name == 'item.texto'){
                return true
            }
        },
        fieldTypeGTIN(){
            if(this.item.name == 'item.codbarras'){
                return true
            }
        },
        fieldFormatGTIN(){
             if(this.item.name == 'item.codbarras'){
                return true
            }
        },
        fieldFormatGTIN(){
             if(this.item.name == 'item.codbarras'){
                return true
            }
        },

        paginalargura: function (){
            return this.pagina.largura * this.multiplicador_pagina
        },

        paginaaltura: function () {
            return this.pagina.altura * this.multiplicador_pagina;
        },

        etiquetalargura: function (){
            return this.calcula_etiqueta_largura(false);
        },

        etiquetaaltura: function () {
            return this.calcula_etiqueta_altura(false);
        },

        etiquetalargura_modoPagina: function (){
            return this.calcula_etiqueta_largura(true)
        },

        etiquetaaltura_modoPagina: function (){
            return this.calcula_etiqueta_altura(true)
        },

        pagina_margin_top: function (tp){
            return this.pagina.margin.top * this.multiplicador_pagina
        },

        pagina_margin_bottom: function (){
            return this.pagina.margin.bottom * this.multiplicador_pagina
        },

        pagina_margin_left: function () {
            return this.pagina.margin.left * this.multiplicador_pagina
        },

        pagina_margin_right: function () {
            return this.pagina.margin.right * this.multiplicador_pagina
        },

        tabEtiqueta(){
            return this.activeTab == 0;
        },

        tabPagina() {
            return this.activeTab == 1;
        },
    },

    watch: {

    },

    beforeDestroy () {

    },

    created () {
        this.setFormat()


        if (this.dadosEtiqueta) {
            const conteudo = this.dadosEtiqueta.conteudo
            this.pagina = conteudo.pagina
            this.items = conteudo.items
            this.etiqueta = conteudo.etiqueta

        }

            //Salvando dados antigos do array
             this.items.map((item, i)=>{
                this.items_backup[i] = {...this.items[i]}
            })
            this.items_backup[0] = {...this.items[0]}

    },

    mounted () {
        this.fields = this.getFields()
    },

}
</script>


<template>
    <div ref="etiqueta">
        <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab" class="mb-4"></tabs>

        <div id="dpi"></div>

        <div v-if="tabEtiqueta" class="row layout-etiqueta"  >
            <div class="default-container col-md-2 col-12 "

                 @drop="onDropItem($event)"
                 @dragover.prevent
                 @dragenter.prevent
                 style="overflow-y: scroll; height: 100vh;">
                 <div>
                     <strong class="lbl-list-title text-secondary">Produto</strong>
                </div>
                <div class="drag-el"
                    v-for="field in fields" v-bind:key="field.name"
                    draggable
                    @dragstart="startDragFields($event, field)"
                    v-if="field.family == 'produto'"
                    >
                    {{ field.label }}
                </div>
                <div class="mt-2">
                     <strong class="lbl-list-title text-secondary">Dados da Empresa</strong>
                </div>
                <div class="drag-el"
                    v-for="field in fields" v-bind:key="field.name"
                    draggable
                    @dragstart="startDragFields($event, field)"
                    v-if="field.family == 'empresa'"
                    >
                    {{ field.label }}
                </div>
                <div class="mt-2">
                     <strong class="lbl-list-title text-secondary">Outros</strong>
                </div>
                <div class="drag-el"
                    v-for="field in fields" v-bind:key="field.name"
                    draggable
                    @dragstart="startDragFields($event, field)"
                    v-if="field.family == 'outros'"
                    >
                    {{ field.label }}
                </div>
            </div>
            <div class="col-md-8 col-12">
                <div class="caixa-layout-etiqueta d-flex justify-content-center"
                     id="foo"
                     @click.stop="item = null" >

                    <div class="drop-zone"
                        :style="'width:'+etiquetalargura+'px;height:'+etiquetaaltura+'px;'" @drop="onDropFields($event)"
                        @dragover.prevent
                        @dragenter.prevent
                        >
                        <vue-draggable-resizable class="drag-el"
                            v-for="aux in items"
                            :id="'item'+aux.index"
                            :w="mmTopx(aux.width)"
                            :h="mmTopx(aux.height)"
                            :x="mmTopx(aux.x)"
                            :y="mmTopx(aux.y)"
                            :min-width="10"
                            :min-height="10"
                            @dragging="(x, y) => onDragingItem(aux.index, x, y)"
                            @resizing="(x, y, width, height) => onResizeItem(aux.index, x, y, width, height)"
                            @activated="() => onActivated(aux.index)"
                            @deactivated="onDeactivated()"
                            :parent="true"
                            :style="handleTextStyle(aux)"
                            :key="aux.index"
                            >
                            <div :style="'width:100%;height:100%;'" @click.stop="">
                            {{ aux.label }}
                            </div>
                        </vue-draggable-resizable>
                    </div>
                </div>
            </div>
            <div class="default-container col-md-2 col-12" >
                 <div v-if="item">
                    <div class="row" >
                        <div class="col-12 d-flex justify-content-between">
                            <v-label :label="item.label"></v-label>
                            <a style="font-size:15px;" href="#" class="btn-sm btn-danger" @click="handleCancelItem(item)"><i class="fa fa-trash"></i></a>
                        </div>
                    </div>
                    <hr>
                    <div class="row" v-if="fieldRotulo" >
                        <form-field v-model="item.rotulo" label="Rótulo" :required="false" :name="item.name + item.index"
                            type="text" col="12"></form-field>
                    </div>
                    <div class="row" v-if="fieldTextFont" >
                        <form-field v-model="item.textFont" label="Fonte" placeholder="Selecione a fonte"  :metadata="{options: optionsFont, label:'Fonte'}" type="select" col="12"
                            :disabled="isView" :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row" v-if="fieldFontSize">
                        <form-field v-model.number="item.fontSize" label="Tamanho" v-validate="{required: false}" type="number" col="7" :name="item.name + item.index">
                        </form-field>
                    </div>
                    <!-- <div class="row d-flex mb-3" v-if="fieldFontSize"> -->
                    <!--     <div class="col-12"> -->
                    <!--         <button :class="item.selectedBold ? 'mr-1 btn-style-font btn-style-font-selected border' : 'mr-1 btn-style-font border'" style="height:30px;" @click="handleBold()"><i class="fa fa-bold"></i></button> -->
                    <!--         <button :class="item.selectedItalic ? 'mr-1 btn-style-font btn-style-font-selected border' : 'mr-1 btn-style-font border'" style="height:30px;" @click="handleItalic()"><i class="fa fa-italic"></i></button> -->
                    <!--     </div> -->
                    <!-- </div> -->
                    <!-- <div class="row" >
                        <form-field v-model="item.currency" label="Moeda" placeholder="Nenhum"  :metadata="{options: optionsCurrency, label:'Moeda'}" type="select" col="12"
                            :disabled="isView"></form-field>
                    </div> -->
                   <div class="row" v-if="fieldTypeGTIN" >
                        <form-field v-model="item.typeGTIN" :metadata="{options:optionsTypeGTIN, label:'Tipo'}" :required="false"
                            type="select" col="12"  :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row" v-if="fieldFormatGTIN" >
                        <form-field v-model="item.formatGTIN" :metadata="{options:optionsFormatGTIN, label:'Formato'}" :required="false"
                            type="select" col="12" :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row d-flex m-auto align-items-center" v-if="fieldFormatGTIN" >
                       <input type="checkbox" class=" mr-0 pr-0" v-model="item.codemtexto">
                       <span class="lbl-edit mt-2 ml-1"  style="font-size:10px;">código em texto</span>
                    </div>
                    <div class="row" v-if="fieldObs">
                        <div class="d-flex flex-column mt-0 col-12 ">
                            <v-label class="lbl-list" label="Observação"></v-label>
                            <textarea class="form-control" v-model="item.obs" cols="20" style="font-size:12px" rows="10" :name="item.name + item.index"></textarea>
                        </div>
                    </div>
                    <hr>
                    <div class="row" v-if="fieldWidth">
                          <form-field v-model="item.width" label="Largura" :v-errors="errors" v-validate="{required:true, name:'Largura'}" :required="true" type="number" col="12"
                            :disabled="isView" :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row" v-if="fieldHeight">
                          <form-field v-model="item.height" label="Altura" :v-errors="errors" v-validate="{required:true, name: 'Altura'}" :required="true" type="number" col="12"
                                :disabled="isView" :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="item.x" label="X" :v-errors="errors" v-validate="{required:true, name:'X'}" :required="true" type="number" col="12"
                            :disabled="isView" :name="item.name + item.index"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="item.y" label="Y" :v-errors="errors" v-validate="{required:true, name: 'Y'}" :required="true" type="number" col="12"
                                :disabled="isView" :name="item.name + item.index"></form-field>
                    </div>



                </div>
                <div v-else>
                    <div class="row" >
                        <div class="col-12">
                            <v-label label="Etiqueta"></v-label>
                        </div>
                    </div>
                    <hr>
                    <div class="row" >
                          <form-field v-model="etiqueta.largura" label="Largura" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                            :disabled="isView" name="etiquetalargura"></form-field>
                    </div>
                    <div class="row" >
                          <form-field v-model="etiqueta.altura" label="Altura" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                            :disabled="isView" name="etiquetaaltura"></form-field>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="tabPagina" class="row layout-etiqueta">
             <div class="default-container col-md-2 col-12">
                <div>
                    <div class="row">
                        <div class="col-12">
                            <v-label label="Pagina"></v-label>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                          <form-field v-model="etiqueta.espacamento_horizontal" label="Espaçamento Horizontal" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusHorizontal" @blur="onBlurHorizontal"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="etiqueta.espacamento_vertical" label="Espaçamento Vertical" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusVertical" @blur="onBlurVertical"></form-field>
                    </div>
                    <div class="row">
                        <form-field v-model="pagina.format" label="Formato" :v-errors="errors" v-validate="{required:true}" :required="true" type="select" col="12"
                            :select-options="formatOptions" :disabled="isView" @input="setFormat()"></form-field>
                    </div>
                    <template v-if="pagina.format == 1">
                        <div class="row">
                            <form-field v-model="pagina.largura" label="Largura" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()"></form-field>
                        </div>
                        <div class="row">
                            <form-field v-model="pagina.altura" label="Altura" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                    :disabled="isView" @input="preview_pagina_nexttick()"></form-field>
                        </div>
                    </template>
                    <div class="row">
                          <form-field v-model="pagina.margin.top" label="Margem Superior" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusSuperior" @blur="onBlurSuperior"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="pagina.margin.bottom" label="Margin Inferior" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusInferior" @blur="onBlurInferior"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="pagina.margin.left" label="Margin Esquerda" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusEsquerda" @blur="onBlurEsquerda"></form-field>
                    </div>
                    <div class="row">
                          <form-field v-model="pagina.margin.right" label="Margin Direita" :v-errors="errors" v-validate="{required:true}" :required="true" type="number" col="12"
                                :disabled="isView" @input="preview_pagina_nexttick()" @focus="onFocusDireita" @blur="onBlurDireita"></form-field>
                    </div>
               </div>
            </div>
            <div class="col-md-10 col-12">
                <canvas id="canvas" class="pagina" :width="(mmTopx(pagina.largura)*1.5)" :height="(mmTopx(pagina.altura)*1.5)"></canvas>
                <!-- <div class="pagina d-flex flex-wrap " -->
                <!--     :style="'width:'+paginalargura+'px;height:'+paginaaltura+'px;padding-top:'+pagina_margin_top+'pxpadding-bottom:'+pagina_margin_bottom+'px;padding-left:'+ pagina_margin_left+'px;padding-right:'+pagina_margin_right+'px;'" -->
                <!--     > -->
                <!--  -->
                <!--     <div class="card"  v-for="n in 10" -->
                <!--         :style="'background-color: #eee; width:'+etiquetalargura_modoPagina+'px;height:'+etiquetaaltura_modoPagina+'px;'" -->
                <!--         > -->
                <!--     </div> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<style>
#dpi {
    height: 1in;
    left: -100%;
    position: absolute;
    top: -100%;
    width: 1in;
}

.drop-zone{
    background-color: #eee;
    margin-bottom: 10px;
}

.drag-el {
    background-color: #ADD8E6;
    margin-bottom: 10px;
    padding: 5px;
}

.layout-etiqueta{
    margin: 10px;
    min-height: 200px;
}

.caixa-layout-etiqueta{
    background-size: 20px 20px;
    background-image: repeating-linear-gradient(to right,transparent 1px,transparent 39px,rgba(0,0,0,.3) 40px,rgba(0,0,0,.3) 40px),repeating-linear-gradient(to bottom,transparent 1px,transparent 39px,rgba(0,0,0,.3) 40px,rgba(0,0,0,.3) 40px);
    border-bottom: 1px solid rgba(0,0,0,.15);
    border-right: 1px solid rgba(0,0,0,.15);
    overflow: auto;
    padding: 10px;
    width: 100%;
    height: 100%;
}

.pagina{
    border: 1px solid rgba(0,0,0,.15);
    overflow: auto;
    width: 100%;
    height: 100%;
    padding: 10px;
}

.btn-style-font{
    padding: 4px 7px;
    border-radius: 5px;
}
.btn-style-font:hover{
    background: #d8d6d6;
    transition: 0.3s;
}
.btn-style-font:focus{
    outline:none;
}

.btn-style-font-selected{
    padding: 4px 7px;
    border-radius: 5px;
    background: #d8d6d6;
}

</style>



// WEBPACK FOOTER //
// src/components/layout-etiqueta.vue